import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '~/eds/src/components/Button/Button';
import chatbot from '~/redux/slices/chatbot';
import { Entity, EntityType } from '~/types/Entity';

import { COLLAPSED_WIDTH } from '../chat-bot-panel/constants';
import { useResolveChatBotEntity } from './useResolveChatBotEntity';

export const AskAnythingButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const chatbotData = useResolveChatBotEntity();
  const isChatBotVisible = useSelector(
    chatbot.selectors.selectIsChatbotVisible,
  );

  const handleToggleChatbot = () => {
    dispatch(chatbot.actions.toggleChatbot());
    dispatch(chatbot.actions.setWidth(COLLAPSED_WIDTH));
  };

  useEffect(() => {
    if (isChatBotVisible) {
      dispatch(
        chatbot.actions.setEntity(chatbotData.entity as Entity<EntityType>),
      );

      if (chatbotData.context) {
        dispatch(chatbot.actions.setContext(chatbotData.context));
      }
    }
  }, [isChatBotVisible]);

  useEffect(() => {
    if (chatbotData.context) {
      dispatch(chatbot.actions.setContext(chatbotData.context));
    }
  }, [chatbotData]);

  return (
    <Button
      iconPosition="left"
      preset="cta-ai"
      text={intl.formatMessage({
        id: 'AskAnythingButton.text',
        defaultMessage: 'Ask AI',
        description: 'Button text to open AI chatbot',
      })}
      disabled={chatbotData.isEntityLoading}
      onClick={handleToggleChatbot}
    />
  );
};
